import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	swich: null,
};

const globalComponents = createSlice({
	name: 'components',
	initialState,
	reducers: {
		changedSwich(state, action) {
			state.swich = action.payload;
		},
	},
});
export const { changedSwich } = globalComponents.actions;
export default globalComponents.reducer;
